export const contacts = {
  phone: '858-888-9927',
  email: 'atechsandiego@gmail.com',
  address: '1114 Skylark Dr. La Jolla, CA 92037',
};
